import { render, staticRenderFns } from "./SupplierTestimoniesControl.vue?vue&type=template&id=f4641ddc&"
import script from "./SupplierTestimoniesControl.vue?vue&type=script&lang=js&"
export * from "./SupplierTestimoniesControl.vue?vue&type=script&lang=js&"
import style0 from "./SupplierTestimoniesControl.vue?vue&type=style&index=0&id=f4641ddc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports